import { Dialog } from '@phi/components';
import { PropType, defineComponent, h } from 'vue';
import { ISubscriptions } from '..';
import { set } from '@phi/util/vuetils';

export const ViewOnlyModal = defineComponent({
    props: {
        subscriptions: {
            required: true,
            type: Object as PropType<ISubscriptions>,
        },
    },

    setup(props) {
        const {
            subscriptions: {
                state: { showing_view_only_modal },
                stripe: { open_store },
            }
        } = props;

        return () => h(Dialog, {
            show: showing_view_only_modal.value,
            'onUpdate:show': set(showing_view_only_modal),
            width: 'narrower',
            title: 'Feature Not Available on Viewer Mode.',
            confirm_label: 'Update Plan',
            onConfirm: () => {
                showing_view_only_modal.value = false;
                open_store();
            },
            onClose: () => showing_view_only_modal.value = false,
        }, () => [
            h('p', 'You are currently subscribed in a View Only plan.'),
            h('p', [
                'You need to ',
                h('a', { href: '#', onClick: open_store }, 'update your plan'),
                ' to use this feature. '
            ]),
        ]);
    }
});
